module.exports = __webpack_public_path__ + "img/celo.574a3a78.svg";